import React from 'react';
import './App.css';
import MainScreen from './screens/MainScreen.tsx';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import RecetaDetalle from './screens/Receta/RecetaDetalle.tsx';
import Recetas from './screens/Recetas/Recetas.tsx';
import TipDetalle from './screens/Tip/TipDetalle.tsx';
import Tips from './screens/Tips/Tips.tsx';
import Activation from './screens/Activation/Activation.tsx';
import Terceros from './screens/Terceros/Terceros.tsx';
import NotFound from './screens/Default/NotFound.tsx';
import '@fontsource/konkhmer-sleokchher';
import '@fontsource-variable/inter';
import UserProfile from './screens/UserProfile/UserProfile.tsx';
import TermsAndConditions from './screens/TermsConditions/TermsConditions.tsx';
import Privacy from './screens/Privacy/Privacy.tsx';
import AuthError from './screens/Default/AuthErrorAlert.tsx';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainScreen />} />
        <Route path="/recetas/:id" element={<RecetaDetalle />} /> {/* Ruta para el detalle */}
        <Route path="/recetas" element={<Recetas />} /> {/* Ruta para Recetas */}
        <Route path="/tip/:id" element={<TipDetalle />} /> {/* Ruta para el detalle */}
        <Route path="/tips" element={<Tips />} /> {/* Ruta para Recetas */}
        <Route path="/activation" element={<Activation />} /> {/* Ruta para el detalle */}
        <Route path="/terceros" element={<Terceros />} /> {/* Ruta para el detalle */}
        <Route path='/UserProfile' element={<UserProfile />} />
        <Route path='/TermsConditions' element={<TermsAndConditions />} />
        <Route path='/Privacy' element={<Privacy />} />
        <Route path="/auth-error" element={<AuthError />} />
        {/* Ruta 404 */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
